import React from "react";
import { FormattedMessage } from "react-intl";
import Anchor from "../Anchor";
import styles from "./styles.css";
const ID = "description";
function Description({ children }) {
    return (React.createElement("section", { id: ID, className: styles.container },
        React.createElement(Anchor, { id: ID, label: React.createElement(FormattedMessage, { id: "DescriptionTitle" }) }),
        children));
}
;
export default Description;
